<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.deptName"
        placeholder="部门名称"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-select v-model="listQuery.status" placeholder="状态" class="filter-item" style="width: 120px;" clearable>
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        搜索
      </el-button>
      <el-button
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
      >
        添加
      </el-button>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="部门名称" min-width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.deptName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="部门代码" width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.deptCode }}</span>
        </template>
      </el-table-column>
      <el-table-column label="描述" min-width="200" align="center">
        <template slot-scope="{row}">
          <span>{{ row.description }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上级部门" width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ (row.parent && row.parent.deptName) || (row.parentId ? `ID:${row.parentId}` : '无') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="100" align="center">
        <template slot-scope="{row}">
          <span>{{ row.orderNum }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" class-name="status-col" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">
            {{ row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.createTime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="140" class-name="small-padding fixed-width">
        <template slot-scope="{row,$index}">
          <el-dropdown trigger="click" @command="command => handleAction(command, row, $index)">
            <el-button type="primary" size="mini">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑</el-dropdown-item>
              <el-dropdown-item command="leaders">设置负责人/分管领导</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 0" command="enabled">启用</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 1" command="disabled">禁用</el-dropdown-item>
              <el-dropdown-item divided command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size" @pagination="getList" />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" class="common-dialog">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="100px" class="common-dialog-form">
        <el-form-item label="部门名称" prop="deptName">
          <el-input v-model="temp.deptName" placeholder="请输入部门名称" />
        </el-form-item>
        <el-form-item label="部门代码" prop="deptCode">
          <el-input v-model="temp.deptCode" placeholder="请输入部门代码" />
        </el-form-item>
        <el-form-item label="上级部门">
          <el-select
            v-model="temp.parentId"
            placeholder="请选择上级部门（不选为根部门）"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="dept in availableParentOptions"
              :key="dept.id"
              :label="dept.deptName"
              :value="dept.id"
          />
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="orderNum">
          <el-input-number v-model="temp.orderNum" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="temp.description" type="textarea" :rows="3" placeholder="请输入部门描述" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="temp.status" class="filter-item" placeholder="请选择状态">
            <el-option v-for="item in statusOptions" :key="item.key" :label="item.display_name" :value="item.key" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="设置负责人/分管领导" :visible.sync="leaderDialogVisible" width="520px" class="common-dialog">
      <el-form :model="leaderForm" label-position="left" label-width="110px" class="common-dialog-form">
        <el-form-item label="部门名称">
          <el-input v-model="leaderForm.deptName" disabled />
        </el-form-item>
        <el-form-item label="部门负责人">
          <el-select v-model="leaderForm.leaderId" placeholder="请选择负责人" style="width: 100%;" clearable filterable>
            <el-option
              v-for="user in userOptions"
              :key="user.id"
              :label="user.nickname || user.username"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="分管领导">
          <el-select v-model="leaderForm.managerId" placeholder="请选择分管领导" style="width: 100%;" clearable filterable>
            <el-option
              v-for="user in userOptions"
              :key="user.id"
              :label="user.nickname || user.username"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leaderDialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="handleUpdateLeaders">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDepartmentList, createDepartment, updateDepartment, updateDepartmentLeaders, deleteDepartment } from '../../../api/department'
import { getAllUsers } from '../../../api/user'
import waves from '../../../directive/waves' // waves directive
import Pagination from '../../../components/Pagination' // secondary package based on el-pagination
import { parseTime } from '../../../utils/index'

export default {
  name: 'DepartmentTable',
  components: { Pagination },
  directives: { waves },
  filters: {
    parseTime,
    statusFilter(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        deptName: undefined,
        status: undefined
      },
      statusOptions: [
        { key: 1, display_name: '启用' },
        { key: 0, display_name: '禁用' }
      ],
      deptOptions: [],
      temp: {
        id: undefined,
        deptName: '',
        deptCode: '',
        description: '',
        parentId: null,
        level: 1,
        orderNum: 0,
        status: 1
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑部门',
        create: '创建部门'
      },
      leaderDialogVisible: false,
      leaderForm: {
        id: undefined,
        deptName: '',
        leaderId: null,
        managerId: null
      },
      userOptions: [],
      dialogPvVisible: false,
      pvData: [],
      rules: {
        deptName: [{ required: true, message: '部门名称不能为空', trigger: 'blur' }],
        deptCode: [{ required: true, message: '部门代码不能为空', trigger: 'blur' }]
      },
      downloadLoading: false
    }
  },
  created() {
    this.getList()
    this.getDeptOptions()
  },
  computed: {
    availableParentOptions() {
      if (!this.temp || !this.temp.id) {
        return this.deptOptions
      }
      return this.deptOptions.filter(item => item.id !== this.temp.id)
    }
  },
  methods: {
    handleAction(command, row, index) {
      switch (command) {
        case 'edit':
          this.handleUpdate(row)
          break
        case 'leaders':
          this.handleManageLeaders(row)
          break
        case 'enabled':
          this.handleModifyStatus(row, 'enabled')
          break
        case 'disabled':
          this.handleModifyStatus(row, 'disabled')
          break
        case 'delete':
          this.handleDelete(row, index)
          break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      const data = {
        page: this.listQuery.page - 1,
        size: this.listQuery.size
      }
      if (this.listQuery.deptName) {
        data.deptName = this.listQuery.deptName
      }
      if (this.listQuery.status !== undefined && this.listQuery.status !== null && this.listQuery.status !== '') {
        data.status = this.listQuery.status
      }
      getDepartmentList(data).then(response => {
        this.list = response.data.content
        this.total = response.data.totalElements

        this.listLoading = false
      })
    },
    getDeptOptions() {
      // 获取全部部门（分页入口拉一批用于选择）
      getDepartmentList({ page: 0, size: 1000 }).then(response => {
        const list = response.data.content || []
        this.deptOptions = list.sort((a, b) => {
          const ao = a.orderNum
          const bo = b.orderNum
          const aHas = ao !== null && ao !== undefined
          const bHas = bo !== null && bo !== undefined
          if (aHas && bHas && ao !== bo) return ao - bo
          if (aHas !== bHas) return aHas ? -1 : 1
          return (a.id || 0) - (b.id || 0)
        })
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getUserOptions() {
      return getAllUsers().then(response => {
        const list = response && response.data ? response.data : []
        this.userOptions = Array.isArray(list) ? list : []
        return this.userOptions
      })
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        deptName: '',
        deptCode: '',
        description: '',
        parentId: null,
        level: 1,
        orderNum: 0,
        status: 1
      }
    },
    handleCreate() {
      this.getDeptOptions()
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          // 设置层级
          if (this.temp.parentId) {
            this.temp.level = 2 // 简单示例，实际应根据父节点层级计算
          } else {
            this.temp.level = 1
          }
          
          createDepartment(this.temp).then(() => {
            this.getList()
            this.getDeptOptions()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleUpdate(row) {
      this.getDeptOptions()
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          updateDepartment(tempData).then(() => {
            this.getList()
            this.getDeptOptions()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    async handleManageLeaders(row) {
      await this.getUserOptions()
      this.leaderForm = {
        id: row.id,
        deptName: row.deptName || '',
        leaderId: row.leaderId || (row.leader && row.leader.id) || null,
        managerId: row.managerId || (row.manager && row.manager.id) || null
      }
      this.leaderDialogVisible = true
    },
    handleUpdateLeaders() {
      const payload = {
        id: this.leaderForm.id,
        leaderId: this.leaderForm.leaderId,
        managerId: this.leaderForm.managerId
      }
      updateDepartmentLeaders(payload).then(() => {
        this.leaderDialogVisible = false
        this.getList()
        this.$notify({
          title: '成功',
          message: '负责人设置成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    handleDelete(row, index) {
      this.$confirm('此操作将永久删除该部门, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDepartment(row.id).then(() => {
          this.list.splice(index, 1)
          this.getDeptOptions()
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
        })
      })
    }
  }
}
</script>